import { AddressType } from "../../Shared/Enums/AddressType";
import { AddressVerificationStatus } from "../../Shared/Enums/AddressVerificationStatus";
import { CountryLookupItem, StateWithCountryLookupItem } from "../../Shared/Models/StateWithCountryLookupItem";

export class Address {
    constructor() {
        this.isEditing = true;
        this.types = new Array<AddressType>();
        this.addressId = 0;
        this.updatedBy = "";
        this.isValid = false;
    }

    public homePhoneNumber: string;
    public officePhoneNumber: string;
    public company: string;
    public company2: string;
    public line1: string;
    public line2: string;
    public city: string;
    public stateCode: string;
    public stateId: number;
    public countryId: number;
    public zipCode: string;
    public faxNumber: string;
    public isValid: boolean;
    public types: Array<AddressType>;
    public isContact: boolean;
    public addressId: number;
    public updatedDate: Date;
    public updatedBy: string;
    public isEditing: boolean;
    public newAreaCode: string;
    public verificationStatus: AddressVerificationStatus;
    public dateOptedIn: Date;
}

export class AddressGridViewModel {
    public addresses: Array<Address>;
    public states: Array<StateWithCountryLookupItem>;
    public countries: Array<CountryLookupItem>;
}